module.exports = __webpack_public_path__ + "static/media/29BDOS1.a42d8ef7.jpg";